// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mLFQA","toggle":"styles_toggle__Zn9H3","preview":"styles_preview__1yuxY"};